import { ReactNode } from 'react';
import { CustomMusicProvider } from '../data/use_custom_music.tsx';
import { FavoritesContextProvider } from '../data/use_favorites.tsx';
import { HymnalsProvider } from '../data/use_hymnals.tsx';
import { CurrentSongProvider } from '../player/current_song.tsx';
import { DualAudioElementProvider } from '../player/dual_audio_element.tsx';
import { SequencerProvider } from '../player/sequencer.tsx';
import { SearchProvider } from './search_control.tsx';
import { DownloadsProvider } from './use_downloads.tsx';
import { MusicCacheProvider } from './use_music_cache.tsx';

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  return (
    <DualAudioElementProvider>
      <CustomMusicProvider>
        <HymnalsProvider>
          <DownloadsProvider>
            <MusicCacheProvider>
              <FavoritesContextProvider>
                <SearchProvider>
                  <CurrentSongProvider>
                    <SequencerProvider>{children}</SequencerProvider>
                  </CurrentSongProvider>
                </SearchProvider>
              </FavoritesContextProvider>
            </MusicCacheProvider>
          </DownloadsProvider>
        </HymnalsProvider>
      </CustomMusicProvider>
    </DualAudioElementProvider>
  );
};
